var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { COLORS } from "../../../../../constants";
var Circle = function (_a) {
    var size = _a.size, color = _a.color;
    return (_jsx(Box, { bgcolor: color, width: size, height: size, borderRadius: "50%" }));
};
// For custom icon passed in, requires 2px around element to look correctly
var IconWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(Box, __assign({ display: "flex", sx: {
            width: "24px",
            minWidth: "24px",
            height: "24px",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: children })));
};
// default behavior, black circle
var CircleWrapper = function (_a) {
    var color = _a.color;
    return (_jsx(Box, __assign({ p: 0.5 }, { children: _jsx(Box, __assign({ display: "flex", sx: {
                width: "20px",
                minWidth: "20px",
                height: "20px",
                backgroundColor: color,
                borderRadius: "50%",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: _jsx(Circle, { color: COLORS.WHITE, size: 6 }) })) })));
};
var IndicatorIcon = function (_a) {
    var icon = _a.icon, bgcolor = _a.bgcolor, _b = _a.circleIconColor, circleIconColor = _b === void 0 ? COLORS.BLACK : _b;
    return (_jsx(Box, __assign({ bgcolor: bgcolor, zIndex: 2, position: "relative" }, { children: icon ? (_jsx(IconWrapper, { children: icon })) : (_jsx(CircleWrapper, { color: circleIconColor })) })));
};
export default IndicatorIcon;
